function modifier() {
	const $price = $('#price');

	const $ModifierMultiple = $('#modifier-multiple');
	if ($ModifierMultiple.length) {
		let $submit = $ModifierMultiple.closest('.content-area').find('[data-cart]'),
			$modCounter = $ModifierMultiple.closest('.variants').find('.modifier-count'),
			$modSum = $ModifierMultiple.closest('.variants').find('.modifier-sum'),
			cntFree = parseInt($ModifierMultiple.data('free-cnt')) || 0,
			price = parseInt($ModifierMultiple.data('price')),
			priceProduct = parseInt($price.attr('data-price')),
			required = $ModifierMultiple.attr('data-required') !== 'false',
			$variants = $ModifierMultiple.find('.variant');

		$('[data-toggle="modifier-counter"]').click(function () {
			let $self = $(this),
				$counter = $self.closest('.counter'),
				sign = $self.data('sign'),
				$input = $counter.find('input[type="number"]'),
				max = parseInt($input.attr('max')),
				step = parseInt($input.attr('step')),
				value = parseFloat($input.val()),
				result = inputQtyResult(value, sign, step);

			if (!isNaN(max)) {
				if (result <= max) {
					if (result > 0) {
						$input.val(result);
					} else {
						$input.val(0);
					}
				} else {
					$input.val(max);
				}
			} else {
				$input.val(result);
			}

			calculator(max);
		});

		function calculator (max) {
			let values = 0, sum = 0;

			$variants.each(function () {
				let $self = $(this),
					val = Number($self.find('[type=number]').val());

				values += val;
			});

			$modCounter.text(values);

			if (cntFree === 0) {
				sum = values * priceProduct;
				$price.text(output_roubles(sum));
			} else {
				if (values > cntFree) {
					sum = (values - cntFree) * price;
				} else  {
					sum = 0;
				}

				$price.text(output_roubles(sum + priceProduct));
				$modSum.text(output_roubles(sum));
			}

			if (values >= max) {
				$('[data-sign="plus"]').attr('disabled', true);
			} else {
				$('[data-sign="plus"]').attr('disabled', false);
			}
		}
	}

	const $ModifierSelect = $('#modifier-select');
	if ($ModifierSelect.length) {
		$('[data-toggle="modifier-select"]').change(function () {
			let $self = $(this),
				$selected = $self.find(":selected"),
				price = parseInt($selected.data('price')),
				pricePrd = parseInt($price.data('price'));

			if (price) {
				pricePrd = pricePrd + price;
			}

			$price.text(output_roubles(pricePrd));

			return false;
		});
	}

	const $ModifierCheckbox= $('#modifier-checkbox');
	if ($ModifierCheckbox.length) {
		$('[data-toggle="modifier-checkbox"]').change(function () {
			let pricePrd = parseInt($price.data('price')),
				sum = 0;

			let $variants = $ModifierCheckbox.find('.variant');
			$variants.each(function () {
				let $variant = $(this),
					$checkbox = $variant.find('[type="checkbox"]'),
					priceVariant = $variant.data('price');

				if ($checkbox.get(0).checked) {
					sum = sum + priceVariant;
				}
			});

			sum = sum + pricePrd;

			$price.text(output_roubles(sum))
		});
	}

	function inputQtyResult(val, sign = '', step = 1, fixed = 0) {
		let result = step;

		if (sign && (sign === 'plus' || sign === 'minus')) {
			if (sign === 'plus') result = val + step;
			if (sign === 'minus') result = val - step;
			if (fixed > 0) result = result.toFixed(fixed);
		}

		return parseFloat(result);
	}
}

export default modifier;
